import React, { useState, useEffect } from 'react';

function StayConnectedForm({ isOpen, onClose }) {
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [isBackHovered, setIsBackHovered] = useState(false);
  const [isUnlockActive, setIsUnlockActive] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setIsAnimating(true);
      }, 100);
    } else {
      setIsAnimating(false);
    }
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setErrors({});
    setSuccess(false);

    if (!formData.name.trim() || !formData.email.trim()) {
      const newErrors = {
        name: !formData.name.trim() ? 'Name is required.' : undefined,
        email: !formData.email.trim() ? 'Email is required.' : undefined,
      };
      setErrors(newErrors);
      setIsSubmitting(false);
      
      
      setFormData({ name: '', email: '' });
      
      
      setTimeout(() => {
        setErrors({});
      }, 3000);
      
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}waitlist/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          source: 'coming_soon_unlock_access',
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const fieldErrors = {};
        for (const key in data) {
          if (Array.isArray(data[key])) {
            fieldErrors[key] = data[key].join(' ');
          }
        }
        setErrors(fieldErrors);
        
        
        setFormData({ name: '', email: '' });
        
        
        setTimeout(() => {
          setErrors({});
        }, 3000);
        
        return;
      }

      setSuccess(true);
      setFormData({ name: '', email: '' });

      if (window.gtag) {
        window.gtag('event', 'waitlist_signup', {
          event_category: 'engagement',
          event_label: 'coming_soon_unlock_access',
        });
      }

      setTimeout(() => {
        onClose();
        setSuccess(false);
      }, 2000);

    } catch (err) {
      console.error('Network error:', err);
      setErrors({ form: 'Network error. Please try again.' });
      
      
      setFormData({ name: '', email: '' });
      
    
      setTimeout(() => {
        setErrors({});
      }, 3000);
      
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="fixed inset-0 bg-black z-[999] overflow-y-auto lg:overflow-hidden"
      >
        <button
          onClick={onClose}
          onMouseEnter={() => setIsBackHovered(true)}
          onMouseLeave={() => setIsBackHovered(false)}
          onTouchStart={() => setIsBackHovered(true)}
          onTouchEnd={() => setIsBackHovered(false)}
          className="absolute top-4 right-4 md:top-6 md:right-6 lg:top-8 lg:right-8 text-white text-base md:text-lg lg:text-xl font-bold hover:text-[#C9A063] active:text-[#C9A063] transition-colors duration-300 z-[1002] flex items-center gap-2"
        >
          <img 
            src="/images/arrow.webp" 
            alt="" 
            className={`transition-all duration-700 ease-in-out w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 ${
              isBackHovered ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0'
            }`}
          />
          Back
        </button>

        <div 
          className={`hidden lg:block absolute left-0 top-0 bottom-0 w-1/3 xl:w-1/2 h-full overflow-visible pointer-events-none transition-all duration-[3000ms]
 ease-out ${
            isAnimating ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full'
          }`}
        >
          <img 
            src="/images/Mask Group 3@2x.png" 
            alt="" 
            className="absolute left-0 top-0 w-auto h-full object-contain object-left"
          />
        </div>

        <div className="relative z-[1001] w-full min-h-full lg:min-h-screen flex flex-col lg:flex-row items-center lg:items-center justify-start lg:justify-end pt-20 pb-0 lg:py-0 px-4 md:px-8 lg:px-16 xl:px-24">
          <div className="w-full max-w-md md:max-w-xl lg:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl flex-shrink-0">
            <div 
              className={`transition-all duration-[3000ms] ease-out ${
                isAnimating ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-full'
              }`}
            >
              <div className="text-center mb-6 md:mb-8 lg:mb-8">
                <h2 
                  className="text-2xl md:text-3xl lg:text-3xl xl:text-4xl font-bold text-white mb-3 md:mb-4 lg:mb-4 leading-tight px-2"
                  style={{ 
                    fontFamily: "'Ojuju', sans-serif",
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale'
                  }}
                >
                  Be The First To Experience What's Coming.
                </h2>
                <p 
                  className="text-sm md:text-base lg:text-base text-white/90 px-2" 
                  style={{ 
                    fontFamily: "'Poppins', sans-serif",
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale'
                  }}
                >
                  Get exclusive access to our launch and early invites to curated experiences.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4 md:space-y-5 lg:space-y-5">
                  {/* Name input */}
                  
                  <div className="flex flex-col mb-3">
                    <div className="relative w-full flex items-center">
                      <div className="absolute left-4 flex items-center justify-center h-full text-white/60 pointer-events-none">
                        <img src="/images/name.webp" alt="" className="w-5 h-5 md:w-5 md:h-5" />
                      </div>
                      <input
                        type="text"
                        name="name"
                        placeholder="Name*"
                        value={formData.name}
                        onChange={handleChange}
                        style={{ backgroundColor: 'transparent' }}
                        className={`w-full pl-12 pr-4 py-3 md:py-4 lg:py-4 text-sm md:text-base lg:text-base bg-transparent focus:bg-transparent border-2 border-white/40 rounded-lg text-white placeholder-white/60 focus:outline-none focus:border-white/70 transition-all duration-300
                          ${errors.name ? 'border-red-400' : ''}`}
                      />
                    </div>
                    {errors.name && <div className="text-red-400 text-sm mt-1 ml-12">{errors.name}</div>}
                  </div>

                  {/* Email input */}
                  <div className="flex flex-col mb-3">
                    <div className="relative w-full flex items-center">
                      <div className="absolute left-4 flex items-center justify-center h-full text-white/60 pointer-events-none">
                        <img src="/images/mail.webp" alt="" className="w-5 h-5 md:w-5 md:h-5" />
                      </div>
                      <input
                        type="email"
                        name="email"
                        placeholder="Email*"
                        value={formData.email}
                        onChange={handleChange}
                        className={`w-full pl-12 pr-4 py-3 md:py-4 lg:py-4 text-sm md:text-base lg:text-base bg-transparent  focus:bg-transparent border-2 border-white/40 rounded-lg text-white placeholder-white/60 focus:outline-none focus:border-white/70 transition-all duration-300
                          ${errors.email ? 'border-red-400' : ''}`}
                      />
                    </div>
                    {errors.email && <div className="text-red-400 text-sm mt-1 ml-12">{errors.email}</div>}
                  </div>

                  {/* Form errors */}
                  {errors.form && <div className="text-red-400 text-center">{errors.form}</div>}

                  {/* Success message */}
                  {success && <div className="text-green-400 text-center">✓ Success! You're on the list.</div>}

                  {/* Submit button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-3 md:py-4 lg:py-4 text-sm md:text-base lg:text-base font-semibold bg-[#826424] hover:bg-[#6b5320] active:bg-[#6b5320] text-white rounded-lg transition-all duration-700 uppercase tracking-wider relative flex items-center justify-center overflow-hidden"
                    onMouseEnter={() => setIsUnlockActive(true)}
                    onMouseLeave={() => setIsUnlockActive(false)}
                    onTouchStart={() => setIsUnlockActive(true)}
                    onTouchEnd={() => setIsUnlockActive(false)}
                  >
                    <div className="relative flex items-center justify-center">
                      <img 
                        src="/images/unlock.webp" 
                        alt="" 
                        className={`absolute -left-8 w-6 h-6 transition-all duration-700 ease-in-out ${
                          isUnlockActive ? 'translate-x-0 opacity-100' : '-translate-x-8 opacity-0'
                        }`}
                      />
                      <span>Get Notified</span>
                    </div>
                  </button>
                </form>

            </div>

            <div 
              className={`mt-4 md:mt-5 lg:mt-5 transition-all duration-[3000ms] ease-out ${
                isAnimating ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'
              }`}
            >
              
            </div>
          </div>

          <div className="block lg:hidden w-screen relative -left-4 md:-left-8 flex-shrink-0 mt-12 pointer-events-none">
            <img 
              src="/images/Mask Group 3.png" 
              alt="" 
              className="w-full h-auto object-cover object-left-bottom"
              style={{ display: 'block', margin: 0, padding: 0 }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default StayConnectedForm;